import { render } from "./advertisement.vue?vue&type=template&id=a8da5770&scoped=true&ts=true"
import script from "./advertisement.vue?vue&type=script&lang=ts"
export * from "./advertisement.vue?vue&type=script&lang=ts"

import "./advertisement.vue?vue&type=style&index=0&id=a8da5770&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8da5770"]])

export default __exports__